import { FormInput } from '../../components/forms/input/FormInput'
import { toAbsoluteUrl } from '../../utils/toAbsolutePath'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { Alert } from '../../components/alerts/Alert'
import { useRecuperarClaveMutation } from '../../redux/api/recuperacion.api'

const Restablecer = () => {
  const formClave = useForm()
  const [recuperarClave, { isError: isErrorClave, isSuccess: isSuccessClave, isLoading: isLoadingClave}] =
    useRecuperarClaveMutation()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = formClave
  const obtenerCorreo = (data:any) => {
    const correoNuevo = data.correo
    const arregloCorreo = {
      correo: correoNuevo
    }
    recuperarClave(arregloCorreo)
  }
  return (
    <>
      <div
        className='border border-dark h-100 w-100'
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className='w-lg-500px bg-white rounded shadow-sm mx-auto'>
          <div className='p-10'>
            <div className='d-flex justify-content-center'>
              <img
                alt='Logo'
                className='h-150px logo'
                src={toAbsoluteUrl('/media/logos/veolia-logo.png')}
              />
            </div>
            <div>
              <div className='text-center py-4'>
                <h1 className='pb-5'>Recuperar contraseña</h1>
                <div className='text-gray-600 fs-4 fw-bold pb-2'>
                  Introduce tu correo y te enviaremos las instrucciones para restablecer tu
                  contraseña
                </div>
                {isErrorClave && (
                  <Alert
                    mensaje='Lo siento, pero la dirección de correo electrónico proporcionada no es válida y no se puede procesar su solicitud.'
                    color='danger'
                    border
                  />
                )}
                {isSuccessClave && (
                  <Alert
                    mensaje='La nueva contraseña ha sido enviada a su dirección de correo electrónico. Revise su bandeja de entrada y utilícela para iniciar sesión en su cuenta.'
                    color='success'
                  />
                )}
              </div>
              {isSuccessClave ? (
                <div className='py-1'>
                  <Link to={'/iniciar-sesion'}>
                    <button className='btn btn-lg btn-primary p-5 fs-3 w-100'>
                      Volver a la pantalla de inicio
                    </button>
                  </Link>
                </div>
              ) : (
                <form onSubmit={handleSubmit(obtenerCorreo)}>
                  <div className='py-2'>
                    <label className='form-label required form-label fs-6 fw-bolder text-dark'>
                      Correo electrónico
                    </label>
                    <FormInput
                      nombreCampo='correo'
                      register={register}
                      tipo='email'
                      errors={errors}
                      isObligatorio={true}
                      placeholder='ejemplo@mail.com'
                    />
                  </div>
                  <div className='py-5'>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary p-5 fs-3 w-100'
                    data-kt-indicator={isLoadingClave ? 'on' : 'off'}
                    disabled={!!isLoadingClave}>
                    <span className='indicator-label'>Enviar</span>
                    <span className='indicator-progress'>
                      Cargando...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                  </div>
                  <div className='py-1'>
                    <Link to={'/iniciar-sesion'}>
                      <button className='btn btn-lg btn-light p-5 fs-3 w-100'>Cancelar</button>
                    </Link>
                  </div>
                </form>
              )}
            </div>
          </div>
          <div className='text-dark order-1 order-md-1 text-center py-3 mt-3'>
            <small className='text-muted ms-3'>v{process.env.REACT_APP_VERSION}</small>
          </div>
        </div>
      </div>
    </>
  )
}

export default Restablecer
